export abstract class StorageKey {
    public static USER_OBJECT = 'user_obj';
    public static MEMBER_OBJECT = 'member_obj';
    public static CONTAINER_OBJECT = 'container_obj';
}